import React from 'react'
import { connect } from 'react-redux'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'
import { Radio, Input, Alert } from 'antd';
import { Select, Switch, Button, Form, Modal, Tooltip } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import { DatePicker, message, Dropdown, Icon } from 'antd';
import { FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon, BackIcon } from '../../core/icons'
import { submit, reduxForm, Field, FieldArray, reset, change, getFormValues } from 'redux-form'
import { push, goBack } from 'react-router-redux'
import moment from 'moment';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import { generateReport, handleRemoteSubmit, remoteSubmit, togglePremium, setAdvancedFilter } from './actions'
import './DataExport.css'
import makeField from '../../account/makeField'

const { MonthPicker, RangePicker } = DatePicker;
const Option = Select.Option;
const OptGroup = Select.OptGroup;

const AInput = makeField(Input)
const ASelect = makeField(Select)
const rangePickerRanges = {
  Today: [moment(), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  'This Year': [moment().startOf('year'), moment().endOf('year')],
  'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
}
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};
// NOTE the only diff from makeField is that is not wrapped with FormItem
const ARangePicker = ({ input, meta, children, hasFeedback, label, ...rest })=>{
  const hasError = meta.invalid;
  // const hasError = meta.touched && meta.invalid;

  return (
      <Form.Item
        {...formItemLayout}
        label={label}
        validateStatus={hasError ? 'error' : 'success'}
        hasFeedback={hasFeedback && hasError}
        help={hasError && meta.error}
      >
        <RangePicker
          ranges={rangePickerRanges}
          className={hasError ? 'has-error': null}
          format={'MM/DD/YYYY'}
          {...input}
          {...rest}
          style={{width: '50%'}}
        />
      </Form.Item>

    )
}

const AdditionalRecipients = () =>
  <Card className="AdditionalRecipients">
    <FieldArray name="additional_recipients" component={({ fields, meta: { error, submitFailed } })=>(
      <ul>
        <li>
          <h2>
            Additional Recipients
            <Button type="button" onClick={() => fields.push('')}>
              Add Recipient
            </Button>
            {submitFailed && error && <span>{error}</span>}
          </h2>
        </li>
        {fields.map((recipient, index) => (
          <li key={index}>
            <Field
              name={`${recipient}`}
              type="text"
              component={AInput}
              label="Recipient"
            />

          </li>
        ))}
      </ul>
    )} />


  </Card>


const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined
const required = value => (value ? undefined : 'Required')

const BasicFilters = ({members, handleReset, toggleMemberOrSummary, showMembersField}) =>
  <Card className="BasicFilters">
    <CardHeader
      title="Basic Filters"
    />
    <Form.Item
      {...formItemLayout}
      label={'Export'}
    >
      <Radio.Group onChange={toggleMemberOrSummary} type="primary" defaultValue={showMembersField?"member":"summary"}>
        <Radio.Button value="summary">Team Summary</Radio.Button>
        <Radio.Button value="member">By Member</Radio.Button>

      </Radio.Group>
    </Form.Item>
    {showMembersField &&
      <Field label="Choose Team Member"
        name="context_user_email"
        component={ASelect}
        style={{width: '50%'}}
        type='input'
        validate={required}
        placeholder="Report for team member..."
        onSelect={handleReset}
      >
        {/* <OptGroup key="members" label="Members:">
        </OptGroup> */}
        { members.map((props, i)=>
          <Option key={i} value={props.email}>{props.email}</Option>
        )}
      </Field>
    }
    <Field label="Dates"
      name="range"
      validate={[(val)=>val && val.length>0 ? undefined : 'Range is empty']}
      component={ARangePicker}
    />

  </Card>

const AdvancedFilters = ({setAdvancedFilter, isPremium, togglePremium, entities, fileTypes}) =>
  <Card className="AdvancedFilters">
    <CardHeader
      title={
        <Tooltip
          title={isPremium?`Congrats! You can apply advanced filters with your premium membership.`:`Premium only filters. Upgrade today!`}
        >
          Advanced Filters
          <CrownIcon width="17" height="17"/>
        </Tooltip>

      }
    />
    <Field label="Format"
      name="file_type"
      component={ASelect}
      style={{width: '50%'}}
      type='input'
      onChange={setAdvancedFilter}
    >
      {fileTypes.map(e=><Option value={e.value}>{e.name}</Option>)}
    </Field>

    <Field label="Export Type"
      name="entity"
      component={ASelect}
      style={{width: '50%'}}
      onChange={setAdvancedFilter}
      type='input'
    >
      {entities.map(e=><Option value={e.value}>{e.name}</Option>)}
    </Field>
  </Card>

const DataExport = ({ showInviteForm, showEmailInput, setAdvancedFilter, invalid, togglePremium, isPremium, pristine, disabled, submitting, generateReport, remoteSubmit, members, handleReset, toggleMemberOrSummary, showMembersField, entities, fileTypes}) =>
  <div className="DataExport">

    <TitleCard showBackButton>
      <h1>Create Data Export</h1>
      <Button loading={submitting} onClick={remoteSubmit} type="primary">Generate Export</Button>
    </TitleCard>

    <BasicFilters members={members} handleReset={handleReset} toggleMemberOrSummary={toggleMemberOrSummary} showMembersField={showMembersField}/>

    <AdvancedFilters
      isPremium={isPremium}
      togglePremium={togglePremium}
      setAdvancedFilter={setAdvancedFilter}
      entities={entities}
      fileTypes={fileTypes}
    />


  </div>


const mapStateToProps = (state) => {
  const userBelongsToGroup = !!state.models.user.group_as_client
    || !!state.models.user.group_as_enterprise_member

  const values = getFormValues('dataExportFormTeams')(state)
  const showTxnOption = state.enterprise.dataExport.teamSummary
  return {
    // NOTE: (bug) even tho vals change, the component doesnt re-render unless obj is passed in
    // rawValues: values,
    showMembersField: !state.enterprise.dataExport.teamSummary,

    // showTxnOption: values && values.context_user!='team-summary',
    // file_typeValues:
    fileTypes: [
      {name: 'Excel (CSV)', value: "csv"},
      ...[!showTxnOption &&{name: 'PDF', value: "pdf"}]
    ],

    entities: !showTxnOption ? [
      {name: 'All', value: ""},
      {name: 'Trips', value: "trips"},
      {name: 'Transactions', value: "transactions"},
      {name: 'Expenses', value: "expenses"},
      {name: 'Revenue', value: "revenue"}
    ] : [
      {name: 'Trips', value: "trips"},
      {name: 'Expenses', value: "expenses"},
      {name: 'Revenue', value: "revenue"},
    ],
    ...state.enterprise.dataExport,
    isPremium: state.models.user.isPremium,
    initialValues: {
      ...state.enterprise.dataExport,
      range: values ? values.range : state.enterprise.dataExport.range
    },
    // initialValues: state.account.dataExport,
    showEmailInput: state.form.dataExportFormTeams
      && state.form.dataExportFormTeams.values
      && state.form.dataExportFormTeams.values.type
      && state.form.dataExportFormTeams.values.type!='self',
    showInviteForm: !userBelongsToGroup,
    members: [
      ...state.enterprise.members.members
    ],
    enableReinitialize: true
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    remoteSubmit: ()=> dispatch(submit('dataExportFormTeams')),
    togglePremium: ()=>  dispatch(togglePremium()),
    setAdvancedFilter: (e, val, prev)=> dispatch(setAdvancedFilter(e, val, prev)),
    handleReset: ()=> {
      // dispatch(change('dataExportFormTeams', 'format', 'csv'))
    },//dispatch(reset('dataExportFormTeams')),
    toggleMemberOrSummary: (e)=> {
      dispatch({type:"TOGGLE_TEAM_SUMMARY"})

      if (e.target.value=='summary'){
        // if (formvalue.file_type=='pdf') dispatch(change('dataExportFormTeams', 'file_type', 'csv'))
        // dispatch(change('dataExportFormTeams', 'entity', ''))
        // dispatch(change('dataExportFormTeams', 'context_user_email', 'team-summary'))
      } else if (e.target.value=="member") {
        // dispatch(reset('dataExportFormTeams'))
        // dispatch(change('dataExportFormTeams', 'context_user_email', null))

      }
    },
  }
}

const DataExportForm = reduxForm({
  form: 'dataExportFormTeams',
  // enableReinitialize: true,
  onSubmit: (values, dispatch, ownProps)=>
    dispatch(generateReport(values))
      .then(()=>message.success('Your Data Export is generating... It will be available here and emailed to you in a minute or two. ', 10))
      .then(()=>dispatch(push("/teams/data-exports")))
      // .then(dispatch({type:'SHOW_SHARE_MODAL'}))
      .catch((error)=>{
        console.log({error})
        // message.warn('Unlock premium to be able to save your work hours.', 10)
      })
})(DataExport)

export default connect(mapStateToProps, mapDispatchToProps)(DataExportForm)



// WEBPACK FOOTER //
// ./src/enterprise/data-export/DataExport.js